import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY_PREFIX = "dproz_roleExplainer_viewed_";

interface UseRoleExplainerViewStateReturn {
	hasViewedRoleExplainer: boolean;
	markRoleExplainerViewed: () => void;
}

export function useRoleExplainerViewState(jobId: string | undefined): UseRoleExplainerViewStateReturn {
	const [hasViewedRoleExplainer, setHasViewedRoleExplainer] = useState(false);

	// Read from localStorage on mount
	useEffect(() => {
		if (typeof window === "undefined" || !jobId) return;

		const storageKey = `${STORAGE_KEY_PREFIX}${jobId}`;
		const stored = localStorage.getItem(storageKey);
		setHasViewedRoleExplainer(stored === "true");
	}, [jobId]);

	// Mark as viewed and persist to localStorage
	const markRoleExplainerViewed = useCallback(() => {
		if (typeof window === "undefined" || !jobId) return;

		const storageKey = `${STORAGE_KEY_PREFIX}${jobId}`;
		localStorage.setItem(storageKey, "true");
		setHasViewedRoleExplainer(true);
	}, [jobId]);

	return {
		hasViewedRoleExplainer,
		markRoleExplainerViewed,
	};
}
